import React from 'react';
import { EntityTitle, NoDataText, TagContainer, TagLabel, TagsWrapper } from '../styled';
import { Wrapper } from './styled';

const EntityTags = ({ entity, values }) => {
  return (
    <Wrapper>
      <EntityTitle children={ entity } />
      { values?.length > 0
        ? <TagsWrapper>{values?.map((tag) => <TagContainer key={ tag?.name ? `${tag?.name}-${tag.id}` : tag }><TagLabel>{ tag?.name || tag }</TagLabel></TagContainer>)}</TagsWrapper>
        : <NoDataText>No tags has been found yet.</NoDataText>
      }
    </Wrapper>
  );
};

export default EntityTags;
